import { BaseApi } from "@newview/infrastructure";
export abstract class ActivitiBaseApi extends BaseApi {
    public get ProxyName(): any {
        return 'ActivitiBaseApi';
    }
  
}